import React from "react";
import "../assets/css/main.css"; // Assure l'import du fichier CSS
import { useTranslation } from "react-i18next";


function Services() {

  const { t } = useTranslation();

  const servicesData = [
    {
      title: t("ServiceTitle1"),
      icon: "bi bi-gear-wide-connected",
      description: t("ServiceDescription1"),
    },
    {
      title: t("ServiceTitle2"),
      icon: "bi bi-cloud-check",
      description: t("ServiceDescription2"),
    },
    {
      title: t("ServiceTitle3"),
      icon: "bi bi-graph-up-arrow",
      description: t("ServiceDescription3"),
    },
    {
      title: t("ServiceTitle4"),
      icon: "bi bi-link",
      description: t("ServiceDescription4"),
    },
    {
      title: t("ServiceTitle5"),
      icon: "bi bi-code-slash",
      description: t("ServiceDescription5"),
    },
    {
      title: t("ServiceTitle6"),
      icon: "bi bi-eye",
      description: t("ServiceDescription6"),
    },
  ];

  return (
    <section className="services-section">
      <section id="services" className="services section">
        {/* Section Title */}
        <div className="container section-title" data-aos="fade-up">
          <h2>Services</h2>
          <h1 className="services-title">{t("ServiceAccroche")}</h1>
        </div>

        <div className="container">
          <div className="row gy-4">
            {servicesData.map((service, index) => (
              <div key={index} className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={100 * (index + 1)}>
                <div className="service-item position-relative">
                  <div className="icon">
                    <i className={service.icon}></i>
                  </div>
                  <a href="#" className="stretched-link" style={{ textDecoration: "none" }}>
                    <h3 style={{ color: "#000", fontWeight: "bold" }}>{service.title}</h3>
                  </a>
                  <p>{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </section>
  );
}

export default Services;
